export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/producer/state.js